import React, {FC, FocusEventHandler, MouseEventHandler} from 'react';
import 'antd/dist/antd.min.css';
import './custom-button.scss';

interface CustomButtonProps {
    prefixIcon?: JSX.Element;
    label?: string;
    suffixIcon?: JSX.Element;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    onMouseEnter?: MouseEventHandler<HTMLButtonElement>;
    onMouseLeave?: MouseEventHandler<HTMLButtonElement>;
    onFocus?: FocusEventHandler<HTMLButtonElement>;
    className?: string;
    isDisabled?: boolean;
}

const CustomButton: FC<CustomButtonProps> = (props) => {
    const {label, prefixIcon, suffixIcon, onClick, onMouseEnter, onMouseLeave, onFocus, className, isDisabled} = props;

    return <button type="button" data-testid={`btn-${label?.toLowerCase?.().replaceAll(' ', '-')}`}
                   className={'custom-btn '.concat(className || '').concat(isDisabled ? ' disabled' : '').trim()}
                   onClick={onClick}
                   disabled={isDisabled} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onFocus={onFocus}>
        <div className={'custom-btn-content-container '.concat(isDisabled ? ' disabled' : '').trim()}>
            {!!prefixIcon && prefixIcon}
            {!!label && <span className="custom-btn-label">{label}</span>}
            {!!suffixIcon && suffixIcon}</div>
    </button>;
};
export default CustomButton;
